module.exports = __webpack_public_path__ + "static/perigoso-palavrinhas-09567f22181b038f1936d8797f8e00c4.jpg";